// extracted by mini-css-extract-plugin
export default {"item":"license_item__Ewl0T","image":"license_image__rstSS"};